// @flow
import queryString from "query-string"

import isEmpty from "common/utils/isEmpty"
import type Journey from "common/records/Journey"

// eslint-disable-next-line flowtype/no-weak-types
export const getUrl = (urlParts: { pathname: string, query?: ?Object }) =>
  `${urlParts.pathname}${
    isEmpty(urlParts.query) ? "" : `?${queryString.stringify(urlParts.query)}`
  }`

export const getJourneyUrl = (baseUrl: string, journey: Journey) => `${baseUrl}#${journey.getId()}`
